import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, TextField, Button, FormControl, FormGroup, FormControlLabel } from "@mui/material";
import { Flex } from "../../style";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import Avatar from '@mui/material/Avatar';
import Logo from '../../assets/Logo';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import HomeIcon from '@mui/icons-material/Home';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import config from '../../config';
import InboxIcon from '@mui/icons-material/Inbox';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ImageIcon from '@mui/icons-material/Image';
import CloseIcon from '@mui/icons-material/Close';
import Alerts from '../Alert';
import CryptoJS from 'crypto-js';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import './Navbar.css';
import getCookie from '../../hooks/getCookie';
import setCookie from '../../hooks/setCookie';
import deleteSession from '../../hooks/deleteSession';
import { getAvatarUrl } from '../../utils/getAvatarUrl';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import NotificationPanel from '../NotificationPanel';
import Badge from '@mui/material/Badge';

export default function Navbar({ isHome, toggleArchiveList, showArchiveList, closeModal, selectedCard }) {
    const backendIp = config.backend_ip;
    const userId = getCookie("userId");
    const username = getCookie("username");
    const nome_completo = getCookie("nome_completo");
    const permissao = getCookie("permissao");
    const sessionId = getCookie("session_id");

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [reporteDialogOpen, setReporteDialogOpen] = useState(false);
    const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
    const [accountDialogOpen, setAccountDialogOpen] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [feedbackType, setFeedbackType] = useState('');
    const [message, setMessage] = useState('');
    const [attachments, setAttachments] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [feedbacks, setFeedbacks] = useState([]);
    const [selectedFeedbackId, setSelectedFeedbackId] = useState(null);
    const [attachmentsFeedback, setAttachmentsFeedback] = useState([]);
    const [alert, setAlert] = React.useState(null);
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');
    const [notificationPanelOpen, setNotificationPanelOpen] = useState(false);
    const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        fetchFeedbacks();
        fetchUnreadNotificationsCount();
        // setCookie("permissao", permissao);
        // setCookie("userId", userId);
    }, []);

    useEffect(() => {
        document.body.className = theme;
        localStorage.setItem('theme', theme);
    }, [theme]);

    const fetchFeedbacks = async () => {
        try {
            const response = await axios.put(`${backendIp}/api/board/ti/list_feedbacks`, {
                user: username,
                session_id: sessionId
            });
            setFeedbacks(response.data);
        } catch (error) {
            return null;
        }
    };

    const fetchUnreadNotificationsCount = async () => {
        try {
            const response = await axios.get(`${backendIp}/api/notifications/count_unread`, {
                params: {
                    user_id: userId,
                    session_id: sessionId,
                    username: username
                }
            });
            setUnreadNotificationsCount(response.data.count);
        } catch (error) {
            setUnreadNotificationsCount(0);
        }
    };

    const handleStatusChange = async (feedbackId, currentStatus) => {
        try {
            // Determina o novo status
            const newStatus = currentStatus === 1 ? 0 : 1;
            // Atualiza o status no banco de dados
            const response = await axios.put(`${backendIp}/api/board/ti/update_feedback`, {
                id_feedback: feedbackId,
                status: newStatus,
                username: username,
                session_id: sessionId
            });
            fetchFeedbacks();
        } catch (error) {
            return null;
        }
    };

    const styles = {
        iconButton: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '&:active': {
                backgroundColor: 'transparent',
            },
        },
    };

    const handleImageClick = (imagePath) => {
        setSelectedImage(imagePath);
    };

    const handleCloseImage = () => {
        setSelectedImage(null);
    };

    const renderAttachments = (attachments) => {
        return attachments.map((attachment) => {
            const fileUrl = `${backendIp}/api/board/ti/get_image/${attachment.file_id}`;
            const fileExtension = attachment.file_name.split('.').pop().toLowerCase();
            return (
                <div key={attachment.file_id} style={{ position: 'relative', display: 'inline-block', marginRight: '5px' }}>
                    <img
                        src={fileUrl}
                        alt={`anexo-${attachment.file_id}`}
                        style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                        onClick={() => handleImageClick(fileUrl)}
                    />
                    <IconButton
                        size='small'
                        style={{ position: 'absolute', top: '-10px', right: '-20px', color: 'red' }}
                        onClick={() => deleteAttachment(attachment.file_id)}
                    >
                        <CloseIcon style={{ fontSize: 'small' }} />
                    </IconButton>
                </div>
            );
        });
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('user', username);
        formData.append('session_id', sessionId);

        try {
            const response = await axios.put(`${backendIp}/api/board/ti/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const { file_id } = response.data;
            const fileName = file.name;
            await axios.put(`${backendIp}/api/board/ti/save_attachment_feedback`, {
                file_id: file_id,
                file_name: fileName,
                user: username,
                session_id: sessionId
            });
            // Adiciona o novo anexo ao state
            setAttachments((prevAttachments) => [
                ...prevAttachments,
                { file_id, file_name: fileName }
            ]);
        } catch (error) {
            return null;
        }
    };

    const handleAccountDialogOpen = () => {
        setAccountDialogOpen(true);
        setDrawerOpen(false); // Fechar o Drawer ao abrir o modal
    };

    const handleAccountDialogClose = () => {
        setAccountDialogOpen(false);
    };

    const handleLogout = () => {
        deleteSession();
        navigate('/');
    };

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const validateFields = () => {
        if (!name || !email || !feedbackType || !message) {
            return false;
        }
        return true;
    };

    const handleReporteDialogOpen = () => {
        if (isHome === true) {
            setReporteDialogOpen(true);
            setDrawerOpen(false); // Fechar o Drawer ao abrir o modal
        } else {
            setReporteDialogOpen(true);
            setDrawerOpen(false); // Fechar o Drawer ao abrir o modal
            if (selectedCard) {
                closeModal();
            }
        }
    };

    const handleReporteDialogClose = async () => {
        setReporteDialogOpen(false);
        setAttachments([]);
        try {
            // Exclui anexos se houver um erro
            await Promise.all(
                attachments.map(async (attachment) => {
                    await deleteAttachment(attachment.file_id);
                })
            );
        } catch (error) {
            return null;
        }
    };

    const handleFeedbacksDialogOpen = () => {
        setFeedbackDialogOpen(true);
        setDrawerOpen(false); // Fechar o Drawer ao abrir o modal
    };

    const handleFeedbacksDialogClose = () => {
        setFeedbackDialogOpen(false);
    };

    const deleteAttachment = async (fileId) => {
        try {
            await axios.put(`${backendIp}/api/board/ti/delete_attachment`, {
                file_id: fileId,
                session_id: sessionId,
                user: username
            });
            // Remove o anexo do state
            setAttachments((prevAttachments) =>
                prevAttachments.filter((attachment) => attachment.file_id !== fileId)
            );
        } catch (error) {
            return null;
        }
    };

    const handleSubmitFeedback = async () => {
        if (!validateFields()) {
            alert('Por favor, preencha todos os campos obrigatórios.');
            return;
        }
        try {
            const response = await axios.put(`${backendIp}/api/board/ti/add_feedback`, {
                nome: name,
                email: email,
                tipodeFeedback: feedbackType,
                mensagem: message,
                user: username,
                session_id: sessionId,
                data: new Date().toISOString()
            });
            const { id_feedback } = response.data;
            // Atualiza o feedback_id dos anexos
            await Promise.all(
                attachments.map(async (attachment) => {
                    await axios.put(`${backendIp}/api/board/ti/update_attachment_feedback`, {
                        file_id: attachment.file_id,
                        feedback_id: id_feedback,
                        username: username,
                        session_id: sessionId
                    });
                })
            );
            setName('');
            setEmail('');
            setFeedbackType('');
            setMessage('');
            setAttachments([]);
            // Define o alerta de sucesso
            setAlert({ message: 'Feedback enviado com sucesso!', severity: 'success' });
            // Remove o alerta após 3 segundos
            setTimeout(() => {
                setAlert(null);
            }, 3000);
        } catch (error) {
            // Define o alerta de erro
            setAlert({ message: 'Erro ao enviar feedback', severity: 'error' });
            // Remove o alerta após 3 segundos
            setTimeout(() => {
                setAlert(null);
            }, 3000);
            // Exclui anexos se houver um erro
            await Promise.all(
                attachments.map(async (attachment) => {
                    await deleteAttachment(attachment.file_id);
                })
            );
        }
    };

    const list = () => (
        <Box
            sx={{ width: 250 }}
            role="presentation"
            onKeyDown={toggleDrawer(false)}
        >
            <List>
                <ListItem className='icon-list' disablePadding>
                    <ListItemButton onClick={() => handleListItemClick(0)}>
                        <ListItemIcon >
                            <PersonIcon className='icon-list' />
                        </ListItemIcon>
                        <ListItemText primary="Conta" />
                    </ListItemButton>
                </ListItem>
                <ListItem className='icon-list' disablePadding>
                    <ListItemButton onClick={() => handleListItemClick(8)}>
                        <ListItemIcon >
                            <InboxIcon className='icon-list' />
                        </ListItemIcon>
                        <ListItemText primary="Fale conosco" />
                    </ListItemButton>
                </ListItem>
                {(username === 'maria_zefiro' || username === 'marcusvinicius_estag') && (
                    <ListItem className='icon-list' disablePadding>
                        <ListItemButton onClick={() => handleListItemClick(9)}>
                            <ListItemIcon >
                                <ThumbUpAltIcon className='icon-list' />
                            </ListItemIcon>
                            <ListItemText primary="Feedbacks" />
                        </ListItemButton>
                    </ListItem>
                )}
                <ListItem className='icon-list' disablePadding>
                    <ListItemButton onClick={() => handleListItemClick(4)}>
                        <ListItemIcon>
                            <LogoutIcon className='icon-list' />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    const handleListItemClick = (index) => {
        if (index === 4) {
            handleLogout();
        } else if (index === 0) {
            handleAccountDialogOpen();
        } else if (index === 8) {
            handleReporteDialogOpen();
        } else if (index === 9) {
            handleFeedbacksDialogOpen();
        }
    };

    const listArchives = async (feedback_id) => {
        try {
            const response = await axios.put(`${backendIp}/api/board/ti/list_attachments`, {
                feedback_id: feedback_id,
                user: username,
                session_id: sessionId
            });
            const archives = response.data;
            if (!Array.isArray(archives)) {
                throw new Error('Formato de resposta inválido');
            }
            return archives;
        } catch (error) {
            return [];
        }
    };

    const handleAccordionChange = async (feedback_id) => {
        setSelectedFeedbackId(feedback_id);
        // Buscar os anexos do feedback selecionado
        const fetchedAttachments = await listArchives(feedback_id);
        setAttachmentsFeedback(fetchedAttachments);
    };

    const formatDate = (dateString) => {
        const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', options);
    };

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    const handleNotificationClick = () => {
        setNotificationPanelOpen(true);
    };

    const handleNotificationPanelClose = () => {
        setNotificationPanelOpen(false);
        // Atualiza contagem após fechar o painel
        fetchUnreadNotificationsCount();
    };

    return (
        <Box sx={{ marginBottom: "60px", position: "fixed", zIndex: "10000", width: "100vw" }}>
            {alert && <Alerts message={alert.message} severity={alert.severity} />}
            <AppBar className='header' position="static">
                <Toolbar>
                    <HomeIcon
                        className='home'
                        style={{ cursor: 'pointer' }}
                        onClick={() => { navigate('/home') }}
                    />
                    <IconButton
                        className='theme'
                        edge="end"
                        color="inherit"
                        aria-label="toggle theme"
                        onClick={toggleTheme}
                        disableRipple
                    >
                        {theme === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
                    </IconButton>
                    <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div onClick={() => { navigate('/home') }} className="logo-navbar">
                            <Logo />
                        </div>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }} className='notifications-usuario'>
                        <IconButton
                            className='notification'
                            color="inherit"
                            onClick={handleNotificationClick}
                            disableRipple
                            sx={{ mr: 1 }}
                        >
                            <Badge badgeContent={unreadNotificationsCount} color="error">
                                <NotificationsRoundedIcon />
                            </Badge>
                        </IconButton>
                        <IconButton
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            onClick={toggleDrawer(true)}
                            disableRipple
                        >
                            <Avatar src={getAvatarUrl(username)} />
                            <Typography variant="body1" color="inherit" sx={{ marginLeft: 1.5 }} className='usuario'>
                                {nome_completo}
                            </Typography>
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Painel de Notificações */}
            <NotificationPanel
                open={notificationPanelOpen}
                onClose={handleNotificationPanelClose}
            />

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                sx={{ zIndex: "12000" }}
            >
                {list()}
            </Drawer>
            <Dialog
                open={accountDialogOpen}
                onClose={handleAccountDialogClose}
                aria-labelledby="account-dialog-title"
                aria-describedby="account-dialog-description"
                PaperProps={{
                    className: 'account-dialog conta'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', position: 'relative', background: 'url("symlink/logo_fundo.png") no-repeat center center', backgroundSize: 'cover', height: '5vw' }}>
                    <div style={{ position: 'relative', top: '90px' }}>
                        <Avatar
                            src={getAvatarUrl(username)}
                            sx={{
                                width: 100,
                                height: 100,
                                position: 'absolute',
                                top: '-50px',
                                left: '10px',
                                zIndex: 1
                            }}
                        />
                    </div>
                </Box>
                <DialogContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '35px' }}>
                        <Typography className='text-navbar-options' style={{ fontSize: '18px' }}>{nome_completo}</Typography>
                        <Typography className='text-navbar-options' style={{ fontSize: '15px' }}>@{username}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <Button
                            onClick={handleLogout}
                            className='button-navbar-options'
                        >
                            Logout
                        </Button>
                        <Button
                            onClick={handleAccountDialogClose}
                            className='button-navbar-options'
                        >
                            Fechar
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
            <Dialog
                open={reporteDialogOpen}
                onClose={handleReporteDialogClose}
                aria-labelledby="help-dialog-title"
                aria-describedby="help-dialog-description"
                PaperProps={{
                    className: 'account-dialog fale-conosco'
                }}
            >
                <DialogTitle className='text-navbar-options' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '23px', fontWeight: '700' }} id="help-dialog-title">Fale Conosco</DialogTitle>
                <DialogContent>
                    <DialogContentText id="help-dialog-description">
                        <div>
                            <Typography className='text-navbar-options' style={{ fontSize: '17px', marginBottom: '15px', marginLeft: '2px' }} gutterBottom>Preencha as informações necessárias para enviar uma mensagem para nossos desenvolvedores:</Typography>
                        </div>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Nome"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="textfield"
                        />
                        <TextField
                            margin="dense"
                            id="email"
                            label="E-mail"
                            type="email"
                            fullWidth
                            variant="outlined"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="textfield"
                        />
                        <FormControl component="fieldset" fullWidth sx={{ marginBottom: '15px' }}>
                            <Typography component="legend" className='text-navbar-options' >Tipo de Feedback</Typography>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={feedbackType === 'Erro'}
                                            onChange={() => setFeedbackType(feedbackType === 'Erro' ? '' : 'Erro')}
                                            className='text-navbar-options'
                                        />
                                    }
                                    label="Erro"
                                    className='text-navbar-options'
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={feedbackType === 'Melhoria'}
                                            onChange={() => setFeedbackType(feedbackType === 'Melhoria' ? '' : 'Melhoria')}
                                            className='text-navbar-options'
                                        />
                                    }
                                    label="Melhoria"
                                    className='text-navbar-options'
                                />
                            </FormGroup>
                        </FormControl>
                        <IconButton disableRipple sx={styles.iconButton} component="label" htmlFor="file-upload" >
                            <Typography className='text-navbar-options'>Anexar Imagem</Typography>
                            <ImageIcon className='text-navbar-options' style={{ fontSize: '21px', marginLeft: '5px' }} />
                            <input
                                id="file-upload"
                                type="file"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />
                        </IconButton>
                        <Flex style={{ marginLeft: '15px' }}>
                            {renderAttachments(attachments)}
                        </Flex>
                        {selectedImage && (
                            <div onClick={handleCloseImage}
                                style={{
                                    position: 'fixed',
                                    backgroundColor: '#1c1d24b6',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    zIndex: 999,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                <img src={selectedImage} alt="selected" style={{ maxWidth: '50vw', maxHeight: '50vh' }} />
                            </div>
                        )}
                        <TextField
                            margin="dense"
                            id="message"
                            label="Mensagem"
                            type="text"
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="textfield"
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleSubmitFeedback}
                        className='button-navbar-options'
                    >
                        Enviar
                    </Button>
                    <Button
                        onClick={handleReporteDialogClose}
                        className='button-navbar-options'
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={feedbackDialogOpen}
                onClose={handleFeedbacksDialogClose}
                aria-labelledby="help-dialog-title"
                aria-describedby="help-dialog-description"
                PaperProps={{
                    sx: {
                        backgroundColor: "#1c1d24",
                        color: 'white',
                        maxWidth: '1000px !important',
                        maxHeight: '85% !important',
                        marginTop: '65px !important',
                        minWidth: '850px !important',
                    }
                }}
            >
                <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '23px', fontWeight: '700' }} id="help-dialog-title">Feedbacks</DialogTitle>
                <DialogContent>
                    <DialogContentText id="help-dialog-description" sx={{ color: 'white' }}>
                        <div>
                            <Typography style={{ color: 'white', fontSize: '17px', marginBottom: '15px', marginLeft: '2px' }} gutterBottom>Feedbacks recebidos:</Typography>
                        </div>
                        {feedbacks.map((feedback) => (
                            <Accordion
                                key={feedback._id}
                                style={{ backgroundColor: '#4f5a63', color: 'white' }}
                                expanded={selectedFeedbackId === feedback.id_feedback}
                                onChange={() => handleAccordionChange(feedback.id_feedback)}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                                    aria-controls={`panel${feedback._id}-content`}
                                    id={`panel${feedback._id}-header`}
                                >
                                    <Typography
                                        style={{
                                            textDecoration: feedback.status === 1 ? 'line-through' : 'none',
                                            color: feedback.status === 1 ? '#009373' : 'white',
                                        }}
                                    >{feedback.mensagem.substring(0, 30)}...  -  {feedback.tipodeFeedback}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>Nome: {feedback.nome}</Typography>
                                    <Typography>Email: {feedback.email}</Typography>
                                    <Typography>Tipo de Feedback: {feedback.tipodeFeedback}</Typography>
                                    <Typography>Data: {formatDate(feedback.data)}</Typography>
                                    <br></br>
                                    <Typography>{feedback.mensagem}</Typography>
                                    <div style={{ marginTop: '15px' }}>
                                        {attachmentsFeedback.map((attachment) => (
                                            <img
                                                key={attachment.file_id}
                                                src={`${backendIp}/api/board/ti/get_file/${attachment.file_id}`}
                                                alt={attachment.file_name}
                                                style={{ maxWidth: '100%', maxHeight: '200px', marginBottom: '10px', marginRight: '15px' }}
                                            />
                                        ))}
                                    </div>
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'right' }}>
                                        <Button
                                            onClick={() => handleStatusChange(feedback.id_feedback, feedback.status)}
                                            style={{ textTransform: 'none', color: 'white', background: '#6e7981', border: 'none', borderRadius: '6px', padding: '10px', width: 'fit-content', cursor: 'pointer', height: '30px', fontSize: '13px', marginTop: '25px' }}
                                        >
                                            Marcar como concluído
                                        </Button>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleFeedbacksDialogClose}
                        style={{ textTransform: 'none', color: 'white', background: 'rgb(49, 57, 64)', border: 'none', borderRadius: '6px', padding: '10px', width: '100px', cursor: 'pointer', height: '40px' }}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}